import { render, staticRenderFns } from "./offer-action.vue?vue&type=template&id=b5aa9574&scoped=true"
import script from "./offer-action.vue?vue&type=script&lang=js"
export * from "./offer-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5aa9574",
  null
  
)

export default component.exports